/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation PhoneNumberoRoutePlanUpdateMutation($routePlanId: ID, $routePlanIds: [ID!], $input: [PhoneNumberoRoutePlanUpdateInput!]!) {
  PhoneNumberoRoutePlanUpdate(routePlanId: $routePlanId, routePlanIds: $routePlanIds, input: $input) {
    id,
    message
    status
  }
}
`
